const OrderMoniteringCateTable = ({ data }) => {

  return (
    <div style={{ width: '160px', border: '1px solid black' }}>
      <div style={{ padding: '3px 0', height: '43px' }} />

      {data?.map(it => 
        <div style={{ borderTop: '1px solid black', textAlign: 'center', padding: '2px 0' }}>
          {it.book_cate2}
        </div>
      )}
    </div>
  )
}

export default OrderMoniteringCateTable